import { useState } from 'react'

export type ReviewView = 'review' | 'plain'

const STORAGE_KEY = 'receivables.reviewSheet.view'

function storedView(): ReviewView {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'plain' ? 'plain' : 'review'
  } catch {
    return 'review'
  }
}

export function useReviewView(): [ReviewView, (view: ReviewView) => void] {
  const [view, setView] = useState<ReviewView>(storedView)
  const choose = (next: ReviewView) => {
    setView(next)
    try {
      window.localStorage.setItem(STORAGE_KEY, next)
    } catch {}
  }
  return [view, choose]
}
